export default __webpack_public_path__ + "static/media/kids about (2).b7f01380.png";